import {TintReturn} from "./TintReturn.js"

export function SetUpOnClick(PassedArray)
{

    for(let i in PassedArray)
    {
        //console.log(PassedArray[i]);
        PassedArray[i][0].on('pointerdown',function(Pointer)
        {
            _onClickOrn(this,Pointer);
        });
    }
    PassedArray[2][2].on('pointerdown',function(Pointer)//quick fuzzbug face fix
    {
        //this.getData('Body')
        _onClickOrn(this.getData('Body'),Pointer);
    });
}
function _onClickOrn(Orn,Pointer)
{
    Orn.scene.InitialCheck = true;
    //console.log(Orn.scene.InitialCheck);
    Orn.scene.input.setDragState(Orn.scene.input.activePointer,0);

    let CopyOf;
    let Attachments = [];
    let AttachmentData = Orn.getData('Attachment');
    let DepthList = Orn.scene.DepthList;
    let EndResult;

    Orn.scene.AudioChan.Chan1.play('pick_up_ornament');

    if(AttachmentData)
    {
        CopyOf = Orn.scene.addImage(0,0,Orn.frame.name);
        CopyOf.setTint(TintReturn(Orn.tintTopLeft));

        //console.log(AttachmentData);
        
        let Cont = Orn.scene.add.container(Pointer.x,Pointer.y,[CopyOf]);

        for (let x in AttachmentData)
        {
            Attachments[x] = Orn.scene.addImage(AttachmentData[x][0],0 - AttachmentData[x][1],AttachmentData[x][2]);
            Cont.add(Attachments[x]);
        }

        const FirstLetter = Orn.frame.name[0];

        switch(FirstLetter)
        {
            case "F":
                Cont.moveTo(Attachments[2],0);
                break;
            case "C":
                Cont.moveTo(Attachments[1],0);
                break;
            case "S":
                Cont.moveTo(Attachments[1],2);
                break;
            default:
                break;
        }

        Cont.setSize(CopyOf.width, CopyOf.height);
        Cont.setDepth(DepthList.TreeItems);

        Cont.setInteractive();
        Orn.scene.input._drag[0][0] = Cont;
        Orn.scene.input._drag[1][0] = Cont
        Orn.scene.input.setDraggable(Cont);

        EndResult = Cont;
    }

    else
    {
        CopyOf = Orn.scene.addImage(Pointer.x,Pointer.y,Orn.frame.name);
        CopyOf.setInteractive();
        CopyOf.setDepth(DepthList.TreeItems);
        Orn.scene.input.setDraggable(CopyOf);
        Orn.scene.input._drag[0][0] = CopyOf;
        Orn.scene.input._drag[1][0] = CopyOf;
        EndResult = CopyOf;
    }

    

    Orn.scene.DragObject = EndResult;

    // orn.scene.input.setDragState(orn.scene.input.activePointer,1);
    // orn.scene.input.setDragState(orn.scene.input.activePointer,2);
    // orn.scene.input.setDragState(orn.scene.input.activePointer,3);
    Orn.scene.input.setDragState(Orn.scene.input.activePointer,4);
}